import React from "react";
import { FormGroup, Label, Input } from "reactstrap";
import Autosuggest from 'react-autosuggest';

const Step1Dance = props => {
  if (props.currentStep !== 1) {
    return null;
  }

  return (
    <>
      <p>How can we reach you?</p>
      <div class="finalstepform">
        <Label for="location">My City</Label>
        <select name="city" value={props.city}
          class="form-control form-control-sm"
          id="city" onChange={props.handleChange}>
          <option value="">Choose your city</option>
          <option value="bengaluru">Bengaluru</option>
          <option value="chennai">Chennai</option>
          <option value="hosur">Hosur</option>
          <option value="others">Others</option>
        </select>
        { props.isothers && 
          <span class="undernotes" >Since you have selected OTHERS, our recommendation will be for ONLINE service providers only. (We are currently operational in the listed cities. Coming soon to your city)</span>
        }
        {props.city!='others' && 
        <>
        <Label for="location">My Locality</Label>
        <Autosuggest 
        suggestions={props.suggestions}
        onSuggestionsFetchRequested={props.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={props.onSuggestionsClearRequested}
        getSuggestionValue={props.getSuggestionValue}
        renderSuggestion={props.renderSuggestion}
        onSuggestionSelected={props.onSuggestionSelected}
        inputProps={props.inputPropsD} 
        />
        </>
        }

        <br/>
        <Label for="username">Dance Type</Label>  <br/>
      <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="check1" name="searchkey" value="78" onChange={props.handleChange} />
      <label class="form-check-label">Bharatnatyam</label>
      </div>
      <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="check2" name="searchkey" value="79" onChange={props.handleChange} />
      <label class="form-check-label">Kuchipudi</label>
      </div>
      <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="check2" name="searchkey" value="80" onChange={props.handleChange} />
      <label class="form-check-label">Odissi</label>
      </div>
      <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="check2" name="searchkey" value="81" onChange={props.handleChange} />
      <label class="form-check-label">Kathak</label>
      </div>
      <br/>
      </div>
    </>
  );
};

export default Step1Dance;
